import { render, staticRenderFns } from "./SwitchBox.vue?vue&type=template&id=b25cdef6&scoped=true&"
import script from "./SwitchBox.vue?vue&type=script&lang=ts&"
export * from "./SwitchBox.vue?vue&type=script&lang=ts&"
import style0 from "./SwitchBox.vue?vue&type=style&index=0&id=b25cdef6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25cdef6",
  null
  
)

export default component.exports